import { useToastContext } from "components/alert/ToastContext";
import BaseCadastro from "components/BaseCadastro";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import { Label } from "components/input/Label";
import CentroCusto from "model/administracao/cadastro/centrocusto/CentroCusto";
import CentroCustoUsuario from "model/administracao/cadastro/centrocusto/CentroCustoUsuario";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import CentroCustoService from "service/administracao/cadastro/centrocusto/CentroCustoService";

const centroCustoService = new CentroCustoService();

export default function CentroCustoCadastro() {

    const [queryParameters] = useSearchParams();

    const { control, clearErrors, setError, setFocus, register, formState: { errors } } = useForm();

    const [centroCusto, setCentroCusto] = useState<CentroCusto>(new CentroCusto());
    const [titulo, setTitulo] = useState<string>('Centro de Custo');
    const [editando, setEditando] = useState<boolean>(false);
    const [usuariosDisponiveis, setUsuariosDisponiveis] = useState<any[]>([]);

    const inputNomeRef = useRef<any>(null);

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    useEffect(() => {

        if (!window.location.pathname.includes("cadastrar")) {
            setEditando(true);
        }

        centroCustoService.usuarios().then(data => {
            setUsuariosDisponiveis(data);
        }).catch(erro => {
            msgErro("Busca de usuários", erro);
        });

    }, [])

    function validar() {

        if (!centroCusto.codigo) {
            setError("codigo", { type: "manual", message: "Código é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!centroCusto.nome) {
            setError("nome", { type: "manual", message: "Nome é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    const usuarioEditor = (options: any) => {
        return <Dropdown
            filter
            filterBy="nome"
            value={options.rowData.usuario}
            options={usuariosDisponiveis}
            optionLabel='nome'
            onChange={(e) => {
                options.rowData['usuario'] = e.target.value;
                let centroCustoLocal = { ...centroCusto };
                centroCusto.centroCustoUsuarios[options.rowIndex] = options.rowData;
                setCentroCusto(centroCustoLocal);
            }}
            style={{ width: '100%' }} placeholder="Selecione um usuário" />;
    }

    return (

        <BaseCadastro model={centroCusto} service={centroCustoService} setModel={(value: CentroCusto) => setCentroCusto(value)} validar={() => validar()} urlService="/centrocusto" pathCadastro="/centrocusto" tituloPagina={'Centro de Custo'}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Código</Label>
                <div className="col-sm-12">
                    <InputText
                        required value={centroCusto.codigo || undefined}
                        className={errors.codigo ? "p-invalid" : ""}
                        style={{ width: '100%' }}
                        {...register("codigo", {
                            onChange: (e) => {
                                setCentroCusto({ ...centroCusto, codigo: e.target.value })
                                clearErrors("codigo")
                            }
                        })}
                    />
                </div>
                {errors.codigo && errors.codigo.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.codigo?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText
                        required value={centroCusto.nome}
                        className={errors.nome ? "p-invalid" : ""}
                        style={{ width: '100%' }}
                        {...register("nome", {
                            onChange: (e) => {
                                setCentroCusto({ ...centroCusto, nome: e.target.value })
                                clearErrors("nome")
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Usuários</Label>
                <div className="col-sm-12">
                    <BaseDataTableEdit
                        isSelection={false}
                        tituloLista="Usuários"
                        getNewModel={() => new CentroCustoUsuario()}
                        dataKey="key"
                        lista={centroCusto.centroCustoUsuarios ? centroCusto.centroCustoUsuarios : []}
                        setLista={(value: any) => setCentroCusto({ ...centroCusto, centroCustoUsuarios: value })}
                        scrollable
                        scrollHeight='500px'
                    >
                        <Column field="usuario.nome" header="Nome" editor={usuarioEditor} />
                        <Column field="usuario.email" header="Email" />
                        <Column body={(rowData: CentroCustoUsuario) => <Checkbox checked={rowData.aprovaViagens} onChange={(e) => {
                            rowData.aprovaViagens = e.checked || false;
                            let centroCustoLocal = { ...centroCusto };
                            setCentroCusto(centroCustoLocal);
                        }} />}
                            header="Aprova viagens" />
                        <Column body={(rowData: CentroCustoUsuario) => <Checkbox checked={rowData.consultaViagens} onChange={(e) => {
                            rowData.consultaViagens = e.checked || false;
                            let centroCustoLocal = { ...centroCusto };
                            setCentroCusto(centroCustoLocal);
                        }} />}
                            header="Consulta viagens" />
                        <Column body={(rowData: CentroCustoUsuario) => <Checkbox checked={rowData.recebeEmailParaAprovarViagem} onChange={(e) => {
                            rowData.recebeEmailParaAprovarViagem = e.checked || false;
                            let centroCustoLocal = { ...centroCusto };
                            setCentroCusto(centroCustoLocal);
                        }} />}
                            header="Recebe solicitações de viagem por email" />
                    </BaseDataTableEdit>
                </div>
            </div>

        </BaseCadastro>
    )
}